import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import TextField from '../TextField/TextField';
import { isEmpty } from '../FormElement/FormElementUtils';
import { EmailValidator } from 'commons-validator-js';
import _ from 'lodash';

const LOCALE_PREFIX = 'components/Email/email';

const validator = new EmailValidator();

export const isValidEmail = (msg) => (value) => {
    if (validator.isValid(value)) {
        return;
    } else {
        return {
            msg,
            className: 'hasError'
        };
    }
};

export const isLongerThanFifty = (msg, country) => (value) => {
    if (value && country === 'us') {
        if (value.length < 50) {
            return;
        } else {
            return {
                msg,
                className: 'hasError'
            };
        }
    }
    return;
};

// This function is only to display when server side validation returns email entered is not available.
// Client side validation happens in NewCustomerForm.
export const isEmailNotAvailable = (msg, emailNotAvailable, emailSubmitted) => (value) => {
    if (emailNotAvailable && (value === emailSubmitted)) {
        return {
            msg,
            className: 'hasError emailUnavailableError'
        };
    }
};

export class Email extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        logEmailValidationErrorInSplunk: PropTypes.bool.isRequired,
        emailNotAvailable: PropTypes.bool,
        emailSubmitted: PropTypes.string,
        country: PropTypes.string
    };

    logEmailValidationError = (event, value) => {
        const { logEmailValidationErrorInSplunk } = this.props;
        if (!validator.isValid(value) && logEmailValidationErrorInSplunk) {
            capeLogSplunk && capeLogSplunk(`Invalid email=${value}`);
        }
    };

    render() {
        const { intl, emailNotAvailable, emailSubmitted, country } = this.props;

        return (
            <div className="vx_col-md-12">
                <Field
                    type="email"
                    id="email"
                    name="email"
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    label={intl.formatMessage({id: `${LOCALE_PREFIX}.email-label`})}
                    arialabel={intl.formatMessage({id: `${LOCALE_PREFIX}.email-label`})}
                    component={TextField}
                    placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.email-placeholder`})}
                    validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.email-empty`})),
                        isValidEmail(intl.formatMessage({id: `${LOCALE_PREFIX}.email-invalid`})),
                        isLongerThanFifty(intl.formatMessage({id: `${LOCALE_PREFIX}.email-invalid-length`}), country),
                        isEmailNotAvailable(intl.formatMessage({id: `${LOCALE_PREFIX}.email-already-exists`}), emailNotAvailable, emailSubmitted)
                    ]}
                    onBlur={this.logEmailValidationError}
                />
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    logEmailValidationErrorInSplunk: _.get(state, 'serverData.featureFlags.wireOnEmailValidationErrorSplunkLogging'),
    // emailNotAvailable and emailSubmitted are to track server side validation error when email entered is not available.
    emailNotAvailable: _.get(state, 'serverData.validationErrorModel.errors.emailNotAvailable'),
    emailSubmitted: _.get(state, 'serverData.validationErrorModel.email'),
    country: _.get(state, 'serverData.country', '')
});

export default connect(mapStateToProps)(injectIntl(Email));
